import { ENTITIES } from './constants';

export const updateEntities = ({ entities, entitiesX }) => ({
  type: ENTITIES.UPDATE,
  payload: {
    entities,
    entitiesX,
  },
});
